/**
 * DeviceTile — apparaat-tegel met icoon, naam, korte uitleg, status badge.
 * Voor device-onboarding grid en /app device-overzicht.
 */
import StatusBadge from './StatusBadge';

const STATUS_MAP = {
  'read-only':       { variant: 'info',    label: 'Alleen meten' },
  'handmatig':       { variant: 'warn',    label: 'Handmatig' },
  'installateur':    { variant: 'neutral', label: 'Installateur nodig' },
  'sturing':         { variant: 'ok',      label: 'Sturing mogelijk' },
  'later':           { variant: 'neutral', label: 'Later beschikbaar' },
};

export default function DeviceTile({
  icon: Icon,
  name,
  hint,
  status = 'read-only',
  onClick,
  testId,
}) {
  const st = STATUS_MAP[status] || STATUS_MAP['read-only'];
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className="text-left rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-emerald-400/30 transition-colors p-3.5 flex flex-col gap-2 min-h-[110px]"
    >
      <div className="flex items-start justify-between gap-2">
        <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-emerald-500/20 text-emerald-300 border border-emerald-400/30">
          {Icon ? <Icon className="w-4 h-4" /> : null}
        </span>
        <StatusBadge variant={st.variant}>{st.label}</StatusBadge>
      </div>
      <div className="flex-1">
        <div className="text-sm font-medium text-white leading-tight">{name}</div>
        {hint && (
          <div className="text-[11.5px] text-white/60 mt-1 leading-snug">{hint}</div>
        )}
      </div>
    </button>
  );
}
